import { objectToArray } from "./data";
import { SORT_BY } from "../actions/sort";
import { sortByKey } from "./presentation";

export const ACCOUNTS_LIMIT = 10000

const sortAccountsByKey = (accounts, sortBy) => {
  const sorts = {
    SORT_BY_NAME: "name",
    SORT_BY_DATE_ASC: "timeCreated",
    SORT_BY_DATE_DESC: "timeCreated",
    SORT_BY_STATUS: "state"
  };
  const asc = sortBy !== SORT_BY.DATE_DESC;

  return sortByKey(accounts, sorts[sortBy], asc);
};

const filterByQuery = (input, query) => {
  let result = input;

  ["state", "paymentMethod"].forEach(k => {
    if (k in query) {
      result = result.filter(a => a[k] === query[k]);
    }
  });
  return result;
};

const attachOwners = (accounts, users) => {
  const ownerRole = 1;
  return accounts.map(a => {
    return Object.assign({}, a, {
      owners: users.filter(
        o => o.account.toString() === a.id.toString() && o.role <= ownerRole
      )
    });
  });
};

export const prepareAccounts = (accounts, users, query, sortOrder) => {
  let accountsArray = objectToArray(accounts);
  const usersArray = objectToArray(users);

  accountsArray = filterByQuery(accountsArray, query);

  accountsArray = attachOwners(accountsArray, usersArray);

  return sortAccountsByKey(accountsArray, sortOrder);
};



// WEBPACK FOOTER //
// ./src/helpers/accounts.js